import { render, staticRenderFns } from "./reservoirInfo.vue?vue&type=template&id=74f02f6c&scoped=true"
import script from "./reservoirInfo.vue?vue&type=script&lang=js"
export * from "./reservoirInfo.vue?vue&type=script&lang=js"
import style0 from "./reservoirInfo.vue?vue&type=style&index=0&id=74f02f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f02f6c",
  null
  
)

export default component.exports